const theme = {
  token: {
    colorPrimary: '#D7503F',
    colorLink: '#D6664A',
    colorError: '#D6664A', // maps @redMain usage
    colorBgLayout: '#F1F1F1', // page background color
  },
  components: {
    // Component-level overrides for @greyDark usage
    Typography: {
      colorText: '#454545',
    },
    Layout: {
      bodyBg: '#F1F1F1',
      headerBg: '#252525',
      siderBg: '#ffffff',
    },
  },
};

export default theme;
